import {setScreen} from '../../services/router';
import JobDetailsContent from './JobDetailsContent/JobDetailsContent';
import {useJobDetailsLogic} from './logics';

export default function JobDetailsPage() {
  const {job, jobApi} = useJobDetailsLogic();

  return <>{job && <JobDetailsContent initJob={job} jobApi={jobApi} />}</>;
}
